import { render, staticRenderFns } from "./RecycleResult.vue?vue&type=template&id=3f71d9bc&scoped=true&"
import script from "./RecycleResult.vue?vue&type=script&lang=js&"
export * from "./RecycleResult.vue?vue&type=script&lang=js&"
import style0 from "./RecycleResult.vue?vue&type=style&index=0&id=3f71d9bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f71d9bc",
  null
  
)

export default component.exports